import { all, takeEvery, put, fork, call, select } from 'redux-saga/effects';
import actions from './actions';

import { logintoSQLSuccessLoadWorkforce } from '../../containers/Page/signin_api';
import { handleError } from '../../errorHandler';

/* eslint-disable no-empty-function */
export function* handleLoadContacts(action) {
  const { token, company_id } = action.payload;
  try {
    const resultWorkforce =
      yield call(logintoSQLSuccessLoadWorkforce, token, company_id);
    if (resultWorkforce.code === 200) {
      // while loop to add all workforce
      for (let i = 0; i < resultWorkforce.workforce.length; i += 1) {
        const worker = resultWorkforce.workforce[i];
        const state = yield select();
        if (i === 0) {
          yield put({
            type: actions.ADD_CONTACT,
            selectedId: worker.id,
            contacts: [worker],
          });
        } else {
          yield put({
            type: actions.ADD_CONTACT,
            selectedId: worker.id,
            contacts: [...state.Contacts.get('contacts'), worker],
          });
        }
      }

      yield put({ type: actions.LOAD_CONTACTS_SUCCESS });
    }
  } catch (e) {
    handleError(`Catch Sage: ${e}`);
    yield put({ type: actions.LOAD_CONTACTS_ERROR });
  }
}

export function* loadContacts() {
  yield takeEvery(actions.LOAD_CONTACTS, handleLoadContacts);
}

export function* loadContactsSuccess() {
  yield takeEvery(actions.LOAD_CONTACTS_SUCCESS, function* () {
  });
}

export function* loadContactsError() {
  yield takeEvery(actions.LOAD_CONTACTS_ERROR, function* () {
  });
}

export function* addContact() {
  yield takeEvery(actions.ADD_CONTACT, function* () { });
}
export function* editContact() {
  yield takeEvery(actions.EDIT_CONTACT, function* () { });
}
export function* deleteContact() {
  yield takeEvery(actions.DELETE__CONTACT, function* () { });
}
export function* deleteAllContacts() {
  yield takeEvery(actions.DELETE__CONTACT, function* () { });
}
export default function* rootSaga() {
  yield all([
    fork(loadContacts),
    fork(loadContactsSuccess),
    fork(loadContactsError),
    fork(addContact),
    fork(editContact),
    fork(deleteContact),
    fork(deleteAllContacts),
  ]);
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/redux/contacts/saga.js